import { render, staticRenderFns } from "./TheComputerAssetEditForm.vue?vue&type=template&id=5056c6f8&scoped=true&"
import script from "./TheComputerAssetEditForm.vue?vue&type=script&lang=js&"
export * from "./TheComputerAssetEditForm.vue?vue&type=script&lang=js&"
import style0 from "./TheComputerAssetEditForm.vue?vue&type=style&index=0&id=5056c6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056c6f8",
  null
  
)

export default component.exports